// extracted by mini-css-extract-plugin
export var colorSquare = "_nu-0";
export var danger = "_nu-5";
export var lightPink = "_nu-8";
export var neutralBlue = "_nu-7";
export var neutralYellow = "_nu-6";
export var normal = "_nu-1";
export var primary = "_nu-2";
export var primaryLight = "_nu-3";
export var solidBlack = "_nu-g";
export var solidGreen = "_nu-b";
export var solidLightBlue = "_nu-d";
export var solidNavy = "_nu-c";
export var solidOrange = "_nu-f";
export var solidPink = "_nu-e";
export var solidRed = "_nu-9";
export var solidYellow = "_nu-a";
export var success = "_nu-4";